import { Input } from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import PropTypes from "prop-types";
import "./fluent-overide.scss";
import CustomFileDropZone from "../DynamicField/CustomFileDropZone/CustomFileDropZone";

export const FileField = ({
  label,
  disabled,
  size,
  type,
  placeholder,
  onChange,
  defaultValue,
  validationMessage,
  required,
  onBlur,
  onKeyDown,
  contentAfter,
  name,
  componentStyle,
  defaultFiles
}) => {
  return (
    <FluentField
      label={label}
      size={size}
      validationMessage={validationMessage}
      required={required}
    >      
      <CustomFileDropZone      
        fromForm={true}
        defaultFiles={defaultFiles}
        onFilesChange={onChange}
        isDisabled={disabled}
      />
    </FluentField>
  );
};

FileField.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string,
  validationMessage: PropTypes.string,
  required: PropTypes.bool,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  contentAfter: PropTypes.any,
  name: PropTypes.string,
  componentStyle: PropTypes.string,
  defaultFiles: PropTypes.array
};
